import { createFileRoute } from "@tanstack/react-router";
import { ApiAccessManager } from "@/components/ApiAccessManager";

function RouteComponent() {
  return <ApiAccessManager />;
}

export const Route = createFileRoute("/_authenticated/api-access-manager/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
